module.exports = __webpack_public_path__ + "static/media/sofia-raciti.4e7814c2.jpg";